var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3538 16.354L14.3538 21.354C14.3073 21.4005 14.2522 21.4373 14.1915 21.4625C14.1308 21.4876 14.0657 21.5006 14 21.5006C13.9343 21.5006 13.8693 21.4876 13.8086 21.4625C13.7479 21.4373 13.6927 21.4005 13.6463 21.354C13.5998 21.3076 13.563 21.2524 13.5378 21.1917C13.5127 21.131 13.4998 21.066 13.4998 21.0003C13.4998 20.9346 13.5127 20.8695 13.5378 20.8088C13.563 20.7481 13.5998 20.693 13.6463 20.6465L18.2932 16.0003L13.6463 11.354C13.5525 11.2602 13.4998 11.133 13.4998 11.0003C13.4998 10.8676 13.5525 10.7403 13.6463 10.6465C13.7401 10.5527 13.8674 10.5 14 10.5C14.1327 10.5 14.26 10.5527 14.3538 10.6465L19.3538 15.6465C19.4003 15.693 19.4372 15.7481 19.4623 15.8088C19.4875 15.8695 19.5004 15.9346 19.5004 16.0003C19.5004 16.066 19.4875 16.131 19.4623 16.1917C19.4372 16.2524 19.4003 16.3076 19.3538 16.354Z",
    fill: "#748181"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#ECEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSolid);
export default __webpack_public_path__ + "static/media/arrow-right-solid.f172a5f4696d8de37a350a9fd1549275.svg";
export { ForwardRef as ReactComponent };